export default __webpack_public_path__ + "static/media/zighinivg.ecc261fc.jpg";